import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../../theme-constants/colors';




export const filterAccordionStyles = makeStyles((theme) => ({
    filterAccordionitem: {
        borderBottom: `1px solid ${tcsmColors.greyFive}`,
        boxShadow: 'none',
        margin: '0',
        width: '100%',
        '&.filter-accordion-item': {
            margin: '0 0 1.5rem 0',
        },
        '&:before': {
            display: 'none',
        },
        '& .filter-accordion': {

            '&-summary': {
                padding: '0 0 .5rem 0',
                position: 'relative',
                '& > div': {
                    margin: 0,
                    display: 'block',
                },

                '& .MuiAccordionSummary-expandIcon': {
                    position: 'absolute', // Position trigger button due to limited html editing capabilities of MUI accordion
                    right: 0,
                    margin: 0,
                    top: 0,

                    '& svg': {
                        fill: tcsmColors.blue,
                    },
                },
            },
            '&-details': {
                padding: '0 0 .5rem 0 ',
                display: 'block',

                '& .show-scroll': {
                    overflowY: 'scroll',
                    maxHeight: '18rem',
                },
            },
        },
        '& .row-header-text, & .row-tooltip': {
            paddingRight: theme.spacing(2),
        },

    },
    searchBar: {
        marginBottom: theme.spacing(1),
        '& .MuiFormControl-root, & .MuiInputBase-root ': {
            display: 'block',
        },
    },



}));
